<template>
  <div>
    <div class="inst-title">파일 손상 검사</div>
    <pre class="inst-desc">모델 검사에 들어가기 전에 오류가 발생한 경우입니다.</pre>

    <div class="inst-subtitle">[해결방법]</div>

    <pre
      class="inst-desc"
    >· 다른 3D프로그램에서 해당 파일이 잘 불러와지는지 확인하기(잘못된 확장자 변환을 시도하거나, 파일이 손상되지 않았는지 확인하기)<br>· 오른쪽 하단 ‘문의하기’ 를 눌러 한양3D팩토리에 문의하기</pre>
  </div>
</template>

<script setup></script>
